export const bankDocumentMessages = {
  'bankDocuments.editForm.title': 'Edit Document Information',

  'bankDocuments.createForm.pageTitle': 'Add New',
  'bankDocuments.createForm.title': 'Add Document Information',

  'documentPeriod.successDelete': 'Document period was deleted.'
}
